import React, { useEffect, useRef, useState } from 'react'
import ElectroTech_Text from '../Logos/ElectroTechLogo_Center.png'
import '../Style/Header.css'
import HamburgerIcon from '../Logos/view-list.svg'
import UserIcon from '../Logos/user-circle.svg'
import SearchIcon from '../Logos/search.svg'
import NotFindIcon from '../Logos/Not-Found.png'
import BlogIcon from '../Logos/newspaper.svg'
import CartIcon from '../Logos/shopping-cart.svg'
import SettingsIcon from '../Logos/settings-account-more (1).svg'
import Logout_Icon from '../Logos/logout-exit.svg'
import Profile_Picture from '../Profile_Pictures/1662741205554.jpg'
import Sections from './Sections'
import { Link } from 'react-router-dom'

function Header() {
    const [ListOpened, SetOpenCloseList] = useState(false)
    const ListContainer = useRef()
    const [SearchBarOpened, ToggleSearchBarStatus] = useState(false)
    const [UserDropDownOpened, ToggleUserDropDownStatus] = useState(false)
    const [Can_Toggle_Search_Bar, SetCan_Toggle_Search_Bar] = useState(true)
    const UserDropDownMenuRef = useRef()
    const SearchBarRef = useRef()
    const ResultPanel = useRef()
    const [SearchedData, SetSearchedData] = useState()
    const [HeaderSection, SetHeaderSection] = useState("lightning")

    const ToggleSearchBar = () => {
        if (Can_Toggle_Search_Bar) {
            if (!SearchBarOpened) {
                ToggleSearchBarStatus(true)
                SetCan_Toggle_Search_Bar(false)
                SearchBarRef.current.style.display = "block"
                setTimeout(() => {
                    SearchBarRef.current.style.width = "450px"
                    setTimeout(() => {
                        ResultPanel.current.style.display = "flex"
                    }, 600);
                    setTimeout(() => {
                        ResultPanel.current.style.height = "340px"
                        setTimeout(() => {
                            SetCan_Toggle_Search_Bar(true)
                        }, 700);
                    }, 700);
                }, 10);
            } else {
                ToggleSearchBarStatus(false)
                SetCan_Toggle_Search_Bar(false)
                ResultPanel.current.style.height = "0px"
                setTimeout(() => {
                    SearchBarRef.current.style.width = "0px"
                    ResultPanel.current.style.display = "none"
                }, 700);
                setTimeout(() => {
                    SearchBarRef.current.style.display = "none"
                    setTimeout(() => {
                        SetCan_Toggle_Search_Bar(true)
                    }, 400);
                }, 1400);
            }
        }
    }

    const Handle_Search_Product = (e) => {
        e.preventDefault()
    }


    const Toogle_User_DropDown_Menu = () => {
        if (!UserDropDownOpened) {
            ToggleUserDropDownStatus(true)
            UserDropDownMenuRef.current.style.display = "flex"
            setTimeout(() => {
                UserDropDownMenuRef.current.style.scale = "1"
            }, 1);
        } else {
            ToggleUserDropDownStatus(false)
            UserDropDownMenuRef.current.style.scale = "0"
            setTimeout(() => {
                UserDropDownMenuRef.current.style.display = "none"
            }, 500);
        }
    }


    const Open_Close_List = () => {
        if (!ListOpened) {
            SetOpenCloseList(true)
            ListContainer.current.style.display = "flex"
            setTimeout(() => {
                ListContainer.current.style.height = "500px"
            }, 40);
        } else {
            SetOpenCloseList(false)
            ListContainer.current.style.height = "0px"
            setTimeout(() => {
                ListContainer.current.style.display = "none"
            }, 400);
        }
    }
    return (
        <>
            <header>
                {!sessionStorage.getItem("LoggedIn") ? <div className='user-profile-container'>
                    <div className='profile-picture' onClick={() => { Toogle_User_DropDown_Menu() }}>
                        {/* <img src={Profile_Picture} alt='profile-image'/> */}
                    </div>
                    <div className='user-dropdown-menu-container' ref={UserDropDownMenuRef}>
                        <div className='user-info'>
                            <div className='username'>Mantegh</div>
                        </div>
                        <Link to={"/cart"} className='cart-row'>
                            <img src={CartIcon} alt='icons' className='user-dropdown-menu-container-icons' />
                            <div className='cart-text'>سبد خرید</div>
                        </Link>
                        <Link to={"/user"} className='settings-row'>
                            <img src={SettingsIcon} alt='icons' className='user-dropdown-menu-container-icons' />
                            <div className='cart-text'>تنظیمات</div>
                        </Link>
                        <div className='logout-row'>
                            <img src={Logout_Icon} alt='icons' className='user-dropdown-menu-container-icons' />
                            <div className='logout-text'>خروج</div>
                        </div>
                    </div>
                </div> : <Link to={'/login'} className='user-button'>
                    <img src={UserIcon} className='user-icon' />
                </Link>}
                <Link to={'/blogs'} className='blog-button'>
                    <img src={BlogIcon} className='blog-icon' />
                </Link>
                <a href='/' className='Header-Logo'><img src={ElectroTech_Text} className='Logo' /></a>
                <div className='menu-toggle-button' onClick={() => { Open_Close_List() }}>
                    <img src={HamburgerIcon} className='menu-toggle-button-icon' />
                </div>
                <div className='products-list-panel-container' ref={ListContainer}>
                    <div className='sections-container'>
                        <div className='section' onMouseOver={() => { SetHeaderSection("lightning") }}>روشنایی</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("fan") }}>تهویه هوا</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("switch") }}>کلید و پریز</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("protector") }}>محافظ های برق</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("cable") }}>سیم و کابل</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("other") }}>لوازم جانبی برق</div>
                        <div className='section' onMouseOver={() => { SetHeaderSection("tasviri") }}>صوتی و تصویری</div>
                    </div>
                    {HeaderSection === "lightning" ? <Sections Section={"lightning"} /> : null}
                    {HeaderSection === "fan" ? <Sections Section={"fan"} /> : null}
                    {HeaderSection === "switch" ? <Sections Section={"switch"} /> : null}
                    {HeaderSection === "protector" ? <Sections Section={"protector"} /> : null}
                    {HeaderSection === "cable" ? <Sections Section={"cable"} /> : null}
                    {HeaderSection === "other" ? <Sections Section={"other"} /> : null}
                    {HeaderSection === "tasviri" ? <Sections Section={"tasviri"} /> : null}
                </div>
                <form onSubmit={(e) => { Handle_Search_Product(e) }} className='search-entire-products'>
                    <div className='toggle-search-bar-button' onClick={() => { ToggleSearchBar() }}>
                        <img src={SearchIcon} className='search-icon' />
                    </div>
                    <input type='search' ref={SearchBarRef} className='search-input' name='searchinp' placeholder='جستجو' />
                    <div className='search-result-panel' ref={ResultPanel}>
                        {SearchedData ? null : <div className='no-product-finded'>
                            <img src={NotFindIcon} className='sad-icon' />
                            <div className='no-item-finded-text'>محصولی پیدا نشد</div>
                        </div>}
                    </div>
                </form>
            </header>
        </>
    )
}

export default Header